import { StoneType } from "@scenes/bulk-request/Utils";
import { ProductCategory } from "@utils/constants";

export const filterDataByProductType = (
  newData: any[],
  productType: number,
  allowedCategories: string[],
  showAll?: boolean
) =>
  newData.filter(
    (item) =>
      (showAll ? true : item.product === productType) &&
      allowedCategories.includes(productTypeToCategory[productType])
  );

export const productTypeToCategory: { [key: string]: string } = {
  "0_single": ProductCategory.DIAMOND,
  "0_pair": `${ProductCategory.DIAMOND}_${StoneType.PAIR}`,
  "0_parcel": `${ProductCategory.DIAMOND}_${StoneType.PARCELS}`,
  "1_single": ProductCategory.LAB_GROWN_DIAMOND,
  "1_pair": `${ProductCategory.LAB_GROWN_DIAMOND}_${StoneType.PAIR}`,
  "1_parcel": `${ProductCategory.LAB_GROWN_DIAMOND}_${StoneType.PARCELS}`,
  "2_single": ProductCategory.GEMSTONE,
  "2_pair": `${ProductCategory.GEMSTONE}_${StoneType.PAIR}`,
  "2_parcel": `${ProductCategory.GEMSTONE}_${StoneType.PARCELS}`,
  "3_single": ProductCategory.JEWELRY,
  "3_pair": ProductCategory.JEWELRY,
  "3_parcel": ProductCategory.JEWELRY,
  "4_single": ProductCategory.LABGROWN_JEWELRY,
  "4_pair": ProductCategory.LABGROWN_JEWELRY,
  "4_parcel": ProductCategory.LABGROWN_JEWELRY,
};

export const selectedSearchGroups = (selectedGroups: Record<string, any>) => {
  return Object.entries(selectedGroups).map(([key, value]) => {
    const productGroupIds =
      value?.length === 1 && value[0] === 0
        ? { vdb_setting: true }
        : { group_ids: value?.join(",") };

    return { [key]: productGroupIds };
  });
};

export const hasLabGrownJewelry = (
  products: Record<string, any>,
  priceMode: number
): boolean => {
  if (!products) return false;
  const labGrownJewelryKey = ProductCategory.LABGROWN_JEWELRY;
  const product = products[labGrownJewelryKey];

  return (
    !!product &&
    Array.isArray(product.price_modes) &&
    product.price_modes.includes(priceMode)
  );
};
